// extracted by mini-css-extract-plugin
export default {"text":"smallText__text__qz35J"};